import { Box, Button, VStack, Text, HStack } from '@chakra-ui/react'
import { FiGrid, FiLogOut } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import { useUserStore } from '@/stores/user.store'
import { logoutApi } from '@/api/auth.api'
import { ROLES } from '@/constants/roles.constants'
import { UNION_MANAGER_ROUTES } from '@/constants/unionRoutes.constants'

export default function NotFoundPage() {
  const navigate = useNavigate()
  const { user, setUser } = useUserStore()

  const logout = async () => {
    try {
      await logoutApi()
    } catch (e) {
      console.warn('Logout safely ignored:', e)
    } finally {
      setUser(null)
      navigate('/login', { replace: true })
    }
  }

  const dashboardPath =
    user?.role === ROLES.ADMIN
      ? '/bo/dashboard'
      : user?.role === ROLES.MANAGER
        ? UNION_MANAGER_ROUTES.orders
        : '/app/user/dashboard'

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
      <VStack gap={6} textAlign="center">
        <Text fontSize="3xl" color="gray.400">
          {'{}'}
        </Text>

        <Text fontSize="xl" fontWeight="semibold">
          Da ist etwas schief gelaufen
        </Text>

        <Text color="gray.500" maxW="420px">
          Leider können wir die gesuchte Seite gerade nicht finden. Hier geht’s weiter:
        </Text>

        <HStack gap={3} pt={2}>
          {user && (
            <Button
              bg="black"
              color="white"
              _hover={{ bg: 'blackAlpha.800' }}
              onClick={() => navigate(dashboardPath)}
            >
              <FiGrid /> Dashboard
            </Button>
          )}

          <Button variant="outline" onClick={logout}>
            <FiLogOut /> Abmelden
          </Button>
        </HStack>
      </VStack>
    </Box>
  )
}
